var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMetaIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0081FB",
  d: "M8.641 48.359c0 3.013.67 5.326 1.547 6.726 1.149 1.833 2.862 2.61 4.61 2.61 2.253 0 4.315-.552 8.287-5.972 3.183-4.344 6.933-10.442 9.456-14.264l4.274-6.477c2.968-4.497 6.404-9.497 10.343-12.886 3.216-2.766 6.685-4.303 10.177-4.303 5.861 0 11.445 3.35 15.718 9.635C77.73 30.31 80 38.979 80 47.925c0 5.318-1.063 9.226-2.871 12.313-1.747 2.986-5.152 5.969-10.88 5.969v-8.513c4.904 0 6.128-4.445 6.128-9.533 0-7.25-1.713-15.296-5.489-21.045-2.679-4.078-6.15-6.57-9.97-6.57-4.132 0-7.456 3.074-11.193 8.554-1.986 2.912-4.025 6.46-6.315 10.463l-2.52 4.405c-5.064 8.855-6.346 10.872-8.878 14.201-4.437 5.829-8.226 8.038-13.214 8.038-5.918 0-9.66-2.528-11.977-6.336C.929 56.767 0 52.694 0 48.054z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#metaIcon_svg__a)",
  d: "M6.813 24.029c3.961-6.024 9.678-10.236 16.235-10.236 3.798 0 7.573 1.109 11.515 4.284 4.312 3.471 8.908 9.187 14.642 18.608l2.056 3.38c4.963 8.156 7.787 12.352 9.44 14.33 2.125 2.542 3.613 3.3 5.547 3.3 4.904 0 6.129-4.446 6.129-9.534l7.622-.236c0 5.318-1.062 9.226-2.87 12.313-1.748 2.986-5.153 5.969-10.881 5.969-3.561 0-6.716-.763-10.205-4.01-2.682-2.491-5.817-6.918-8.229-10.897L40.639 39.48c-3.6-5.933-6.902-10.357-8.813-12.36-2.056-2.154-4.7-4.756-8.917-4.756-3.413 0-6.312 2.363-8.738 5.977z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#metaIcon_svg__b)",
  d: "M22.91 22.363c-3.413 0-6.312 2.363-8.738 5.977-3.43 5.107-5.531 12.714-5.531 20.019 0 3.013.67 5.326 1.547 6.726L2.82 59.87C.929 56.768 0 52.695 0 48.055c0-8.438 2.348-17.233 6.813-24.025 3.962-6.024 9.679-10.236 16.236-10.236z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "metaIcon_svg__a",
  x1: 16.97,
  x2: 72.05,
  y1: 45.9,
  y2: 48.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0064E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#0064E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#0073EE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0082FB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "metaIcon_svg__b",
  x1: 12.519,
  x2: 12.519,
  y1: 51.937,
  y2: 31.904,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0082FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0064E0"
})))));
export default SvgMetaIcon;